import { Fragment } from 'react';
import { Page } from '../theme/elements/Page';
import { Box, Stack, Typography } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { PaymentsPurposeTable } from 'sections/PaymentsPurposeManagement/PaymentsPurposeTable';
import { getPaymentsPurpose } from 'state/reducers/global.reducer';
import { ButtonComponent } from 'components/ButtonComponent';
import { Link, useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';

export const PaymentsPurposeManagementApp = () => {
	const t = useAppSelector(selectTranslations);
	const paymentsPurposeEditPermission = hasPermission([permissionEnums.EDIT_PAYMENTS_PURPOSE]);
	const paymentsPurpose = useAppSelector(getPaymentsPurpose);
	const navigate = useNavigate();

	return (
		<Fragment>
			<Page>
				<>
					<Stack gap={6}>
						<Stack gap={2}>
							<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
								<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
									<Typography variant="pageTitle">
										{t('page.payments_purpose_management.title')}
									</Typography>
								</Box>
								<ButtonComponent
									handleClick={() => navigate(`/${pagesEnum.PAYMENTS_PURPOSE_MANAGEMENT}/new`)}
									text={t('label.add_new')}
								/>
							</Box>
							<Stack gap={1}>
								<Typography variant="boldBody1">
									{t('page.payments_purpose_management.warning.title')}
								</Typography>
								<Link
									target="_blank"
									to="https://support.currencycloud.com/hc/en-gb/articles/360017430000-Payment-Purpose-Codes"
								>
									PAYMENT PURPOSE CODES
								</Link>
							</Stack>
						</Stack>
						{paymentsPurposeEditPermission && <PaymentsPurposeTable paymentsPurpose={paymentsPurpose} />}
					</Stack>
				</>
			</Page>
		</Fragment>
	);
};
